import React from 'react';
import { useSelector } from 'react-redux';
import { Box, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import PlanCard from '../PlanCard';
import PlanCardCar from '../PlanCardCar';

import './style.scss';

const useStyles = makeStyles((theme) => ({
  carouselContainer: {
    scrollSnapType: 'x mandatory',
    overflowX: 'hidden',
    overflowY: 'hidden',
    scrollBehavior: 'smooth',
  },
  headerTitleCar: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#004987',
    textAlign: 'center',
  },
}));

export default function CardsCarousel({ plans, ...props }) {
  const { insuranceName } = useSelector(({ insurances }) => ({
    insuranceName: insurances.selected.insuranceName,
  }));

  const classes = useStyles();
  const carouselRef = React.createRef();
  const childRef = React.createRef();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up('sm'));

  const planCards = plans.map((plan, key) => {
    return (
      <Box key={key} py='10px' px='8px'>
        {insuranceName === 'AUTOMOTOR' ? (
          <PlanCardCar
            plan={plan}
            headerTitleCar={classes.headerTitleCar}
            ref={childRef}
            {...props}
          />
        ) : (
          <PlanCard plan={plan} ref={childRef} {...props} />
        )}
      </Box>
    );
  });

  function handlePrev() {
    let width = childRef.current.getBoundingClientRect().width;
    width += sm ? 16 : 16;
    carouselRef.current.scrollBy(-width, 0);
  }

  function handleNext() {
    let width = childRef.current.getBoundingClientRect().width;

    width += sm ? 16 : 16;
    carouselRef.current.scrollBy(width, 0);
  }

  return (
    <Box display='flex' alignItems='center' width='100%'>
      <Box className='arrow prev' onClick={handlePrev}></Box>
      <Box
        overflow='hidden'
        display='flex'
        width='100%'
        className={classes.carouselContainer}
        ref={carouselRef}
      >
        {planCards}
      </Box>
      <Box className='arrow next' onClick={handleNext}></Box>
    </Box>
  );
}
